import React from "react";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { Button } from "../ui/Button";

export default function CTASection() {
  return (
    <section className="relative py-24 lg:py-32 bg-gradient-to-br from-[#0a1628] via-[#0f1f35] to-[#0a1628] overflow-hidden">
      {/* Animated background blobs */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <motion.div
          animate={{
            scale: [1, 1.2, 1],
            opacity: [0.3, 0.6, 0.3],
          }}
          transition={{ duration: 8, repeat: Infinity }}
          className="absolute top-0 left-1/4 w-[600px] h-[600px] rounded-full bg-[#2dd4bf]/20 blur-3xl"
        />
        <motion.div
          animate={{
            scale: [1.2, 1, 1.2],
            opacity: [0.3, 0.6, 0.3],
          }}
          transition={{ duration: 10, repeat: Infinity, delay: 1 }}
          className="absolute bottom-0 right-1/4 w-[600px] h-[600px] rounded-full bg-blue-500/20 blur-3xl"
        />
      </div>

      <div className="relative z-10 max-w-4xl mx-auto px-6 text-center">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
        >
          <h2 className="text-4xl md:text-5xl font-light text-white mb-6">
            Ready to Secure Your
            <br />
            Healthcare AI Systems?
          </h2>
          <p className="text-slate-400 text-lg mb-10 max-w-2xl mx-auto">
            Join the beta program launching January 2026. Be among the first
            healthcare organizations to experience comprehensive AI security.
          </p>

          <div className="flex flex-wrap justify-center gap-4">
            {/* Using the variant and size system from our UI Button */}
            <a
              href="https://calendly.com/ciphergenix/30min"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block"
            >
              <Button className="bg-[#2dd4bf] hover:bg-[#2dd4bf]/90 text-black px-8 py-6 text-lg rounded-full font-semibold shadow-lg shadow-[#2dd4bf]/30">
                Request Early Access
                <ArrowRight className="ml-2 w-5 h-5" />
              </Button>
            </a>

            <a
              href="https://calendly.com/ciphergenix/30min"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block"
            >
              <Button className="bg-white/10 hover:bg-white/20 text-white px-8 py-6 text-lg rounded-full font-semibold border border-white/20 backdrop-blur-sm">
                Join Beta
              </Button>
            </a>
          </div>

          <p className="mt-8 text-slate-500 text-sm">
            MVP launching Q1 2026 • Beta spots limited • 18-month technical lead
          </p>
        </motion.div>
      </div>
    </section>
  );
}
